import Vue, { createApp } from 'vue'
import { initCustomApp } from '@/utils/initialization'

// import Navigation from '@/components/Navigation.vue'
// import Logout from '@/components/Logout.vue'

import VueUniversalModal from 'vue-universal-modal'

// initCustomApp(createApp(Navigation)).mount('#app-navigation')
// initCustomApp(createApp(Logout)).mount('#app-logout')

import ProductOrderPaymentModal from "@/components/modals/ProductOrderPaymentModal.vue";

export default function init(appComponent: any, selector = '#app', customInit?: (app: Vue.App<any>) => void) {
    const app = initCustomApp(createApp(appComponent))

    app.use(VueUniversalModal, {
        teleportTarget: '#modals',
    });

    app.directive('profile-avatar', function(el, binding) {
        el.classList.toggle('profile-avatar--empty', !binding.value);
        el.style.backgroundImage = binding.value ? `url('${binding.value}')` : '';
    });

    app.component('ProductOrderPaymentModal', ProductOrderPaymentModal); // we need this otherwise weird bug (?) that the modal component can not be found by Vue in cases

    if( customInit ) {
        customInit.call(undefined, app);
    }

    app.mount(selector);
}
